import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './CtaButton';
export function Faq() {
  return <section className="bg-cream py-16 sm:py-24" data-id="element-120" data-mp="1lctv4lsfqxge">
      <div className="mx-auto max-w-3xl px-4" data-id="element-121" data-mp="1l9fw9nizd6dp">
        <SectionHeading eyebrow="Frequently Asked Questions" title="Your Questions, Answered" data-id="element-122" data-mp="1gdqst93ub5c4" />

        <div className="mt-10 space-y-3" data-id="element-123" data-mp="2dzennpkndflj">
          {faqs.map(f => <details key={f.q} className="group rounded-2xl bg-white shadow-[0_6px_24px_-18px_rgba(16,42,76,0.4)]" data-id="element-124" data-mp="290tlvlpqynuz">
              <summary className="flex cursor-pointer items-center justify-between gap-4 p-5 text-left text-base font-bold text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-accent rounded-2xl sm:text-lg" data-id="element-125" data-mp="241gx2vfbf6pr">
                {f.q}
                <ChevronDownIcon className="h-5 w-5 shrink-0 text-accent transition-transform duration-200 ease-out group-open:rotate-180" aria-hidden="true" data-id="element-126" data-mp="sl0ggys0yk1b" />
              </summary>
              <div className="space-y-3 px-5 pb-5 text-[15px] leading-relaxed text-muted" data-id="element-127" data-mp="uhkg3xw5fq4t">
                {f.a.map(p => <p key={p} data-id="element-128" data-mp="fiyqbusfpu3q">{p}</p>)}
              </div>
            </details>)}
        </div>

        <div className="mt-10" data-id="element-129" data-mp="kh09sgtrvvfq">
          <CtaButton label="My Questions Are Answered — I Want It Now" data-id="element-130" data-mp="6rgcvrmvhsec" />
        </div>
      </div>
    </section>;
}